import * as fromModelosEjecutados from '../../actions/AdmMapa/ModelosEjecutados.actions';
import { datosModelo } from 'src/app/models/SicarMap/datosModelo.model';


export interface ModelosEjecutadosState {
    accion: string;
    valor: string;
    listaModelosEjecutados: datosModelo[];
}

const initialState: ModelosEjecutadosState = {
    accion : '',
    valor: '',
    listaModelosEjecutados : []
};

export function ModelosEjecutadosReducer( state = initialState , action: fromModelosEjecutados.ModelosEjecutadosActions) : ModelosEjecutadosState{
    switch (action.type) {
        case fromModelosEjecutados.SET_MODELO:
            return {
                ...state,
                accion: 'Set',
                valor : action.modeloEjecutado.id,
                listaModelosEjecutados: [...state.listaModelosEjecutados, action.modeloEjecutado]
            };
        case fromModelosEjecutados.UPDATE_MODELO:
            return {
                ...state,
                accion: 'Update',
                valor: action.modeloEjecutado.id,
                listaModelosEjecutados: state.listaModelosEjecutados.map((x: datosModelo) => {
                    if (x.id === action.modeloEjecutado.id) {
                        x = action.modeloEjecutado;
                    }
                    return x;
                })
            };
        case fromModelosEjecutados.UNSET_MODELO:

            const  modeloEliminar = state.listaModelosEjecutados.find( x => x.id === action.IdModelo);
            if (modeloEliminar) {
                const IndiceE = state.listaModelosEjecutados.indexOf(modeloEliminar);
                state.listaModelosEjecutados.splice( IndiceE, 1);
            }
            const modelos = state.listaModelosEjecutados;
            return {
                ...state,
                accion: 'Unset',
                valor: action.IdModelo,
                listaModelosEjecutados: modelos
            };
        default:
            return state;
    }
}
